import './style.css';
import { useNavigate } from 'react-router-dom';

const ServerError = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/home');
  };

  return <div className="server-error">Server error</div>;
};

export default ServerError;
